import { TableCell, TableCellProps, TableHead, TableRow } from '@mui/material'
import { FC } from 'react'

export interface TableColumn extends TableCellProps {
    maxWidth: number
    label: string
    id: string
}

interface Props {
    columns: TableColumn[]
}

export const BillingTableHeading: FC<Props> = ({ columns }) => (
    <TableHead>
        <TableRow>
            {columns.map((column, index) => (
                <TableCell
                    align={column.align}
                    sx={{
                        background: '#F5F5F5',
                    }}
                    key={column.id}
                    style={{
                        maxWidth: column.maxWidth,
                        borderTopLeftRadius: index === 0 ? '16px' : 0,
                        borderTopRightRadius: index === columns.length - 1 ? '16px' : 0,
                    }}>
                    {column.label}
                </TableCell>
            ))}
        </TableRow>
    </TableHead>
)
